export default __webpack_public_path__ + "static/media/banner-hpc.1637a957.png";